import React, { Component } from 'react';
import { IosToggle, FlipToggle, SkewToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

const components = {
    FlipToggle,
    SkewToggle
}

const iframes = [
    `//codepen.io/nerdchacha/embed/yMPLMx/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/MpOWpP/?theme-id=dark&default-tab=js&embed-version=2`,
]

class Checked extends Component {
    render() {
        return (
            <Tabs defaultActiveKey={0} id="uncontrolled-tab-example" className="card" >
                <Tab eventKey={0} title='IosToggle'>
                    <IosToggle
                        onProps={{style: {backgroundColor: '#77ab59', color: 'black', toggleBorder: '#36802d', buttonBorder: 'blue'}, component: <FontAwesome name='check' />}}
                        offProps={{style: {backgroundColor: '#f22525', color: 'white', toggleBorder: '#d92323', buttonBorder: 'orange'}, component: <FontAwesome name='times' />}}
                        toggleIcon={{style: {backgroundColor: 'yellow'}}}
                    />
                    <iframe
                        height='265'
                        scrolling='no'
                        title='aJyPJy'
                        src='//codepen.io/nerdchacha/embed/OpOJQO/?theme-id=dark&default-tab=js&embed-version=2'
                        frameBorder='no'
                        allowTransparency='true'
                        allowFullScreen='true'
                    />
                </Tab>
                {Object.keys(components).map((key, i) => (
                    <Tab eventKey={i+1} key={i+1} title={key}>
                        {
                            React.createElement(components[key], {
                                onProps: {style:{color: '#ccc', backgroundColor: '#93ca3b'}, component: (<FontAwesome name='check' />)},
                                offProps: {style:{color: 'rgba(169,294,40,0.9)', backgroundColor: '#ff0030'}, component: 'Nah!'}
                            })
                        }
                        <iframe
                            height='265'
                            scrolling='no'
                            title='aJyPJy'
                            src={iframes[i]}
                            frameBorder='no'
                            allowTransparency='true'
                            allowFullScreen='true'
                            >
                        </iframe>
                    </Tab>
                ))}
            </Tabs>
        );
    }
}

export default Checked;



// WEBPACK FOOTER //
// ./src/components/OnOffColor.js